import React from 'react';
import { times } from 'lodash-es';

import Skeleton from '../../../Skeleton';

export default {
  header: {
    metaContainer: (
      <div className="company-meta-container">
        <Skeleton height={80} width={80} />
        <Skeleton height={64} width={200} />
      </div>
    ),
    companyPageLink: <Skeleton height={32} width={118} />,
  },
  minHeader: {
    metaContainer: <Skeleton height={24} width={180} />,
    companyPageLink: <Skeleton height={24} width={101} />,
  },
  dataStrengthIndicator: <Skeleton height={24} width={150} />,
  kpiSpotlight: {
    cardTitle: <Skeleton height={23.4} width={240} />,
    cardBody: (
      <>
        <Skeleton height={24} />
        <Skeleton height={24} style={{ marginTop: 8 }} />
        <Skeleton height={24} style={{ marginTop: 8 }} />
      </>
    ),
  },
  drivers: {
    baseChart: (
      <div className="drivers-chart-layout">
        <Skeleton height={278} />
      </div>
    ),
  },
  pubContribution: (
    <div className="pub-contribution-qv__content-table">
      {times(7).map(n => <Skeleton key={n} height={n === 0 ? 18 : 15.4} />)}
    </div>
  ),
};
